import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Nav, NavItem, NavMenu } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

import { createCommandAttributes } from '../commandAttributes';

interface IReportsNavProps {
  indented?: boolean;
}

function ReportsNav({ indented = true }: Readonly<IReportsNavProps>): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();

  const conversionsNav = (
    <Nav indented={true} label={t('Conversions navigation')} type={'vertical'}>
      <NavItem
        {...createCommandAttributes({
          description: t('View conversions dashboard'),
          keywords: 'reports,conversions,dashboard',
          label: t('Conversions Dashboard'),
        })}
        to={localUrl('/reports/conversions/dashboard')}
      >
        {t('Dashboard')}
      </NavItem>
      <NavItem
        {...createCommandAttributes({
          description: t('Manage conversion goals'),
          keywords: 'reports,conversions,goals,goal manager',
          label: t('Goal Manager'),
        })}
        to={localUrl('/reports/conversions/goal-manager')}
      >
        {t('Goal Manager')}
      </NavItem>
    </Nav>
  );

  return (
    <Nav indented={indented} label={t('Reports navigation')} type={'vertical'}>
      <NavItem
        {...createCommandAttributes({
          description: t('View audience engagement report'),
          keywords: 'reports,audience,engagement',
          label: t('Audience Engagement'),
        })}
        to={localUrl('/reports/audience-engagement')}
      >
        {t('Audience Engagement')}
      </NavItem>
      <NavMenu
        {...createCommandAttributes({
          description: t('Conversions reports'),
          keywords: 'reports,conversions',
          label: t('Conversions'),
        })}
        menu={conversionsNav}
        to={localUrl('/reports/conversions')}
      >
        {t('Conversions')}
      </NavMenu>
    </Nav>
  );
}

export default ReportsNav;
